<template>
  <div class="demandBox">
    <div class="demandDetails w1200Auto">
      <div class="flex-item-center breadcrumb">
        <span style="font-size: 14px; padding-left: 5px">当前位置：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/supplyHome' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item
            style="cursor: pointer"
            :to="{ name: 'demandList' }"
            >需求列表</el-breadcrumb-item
          >
          <el-breadcrumb-item style="color: #009999"
            >需求详情</el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>
      <div class="demandDetails_box bacgk">
        <h3><b>{{ data.demandName }}</b></h3>
        <div class="flex-item-center">
          <div class="box_mesg_cont">
            <div class="flex-item-center box_mesg">
              <p>
                需求编号： <span>{{ data.demandNumber }}</span>
              </p>
              <p>
                计价币种： <span>{{ data.coin }}</span>
              </p>
              <p>
                需求预算：
                <span class="red" v-if="data.budgetType == 0">{{
                  data.budgetPrice
                }}</span>
                <span class="red" v-else-if="data.budgetType == 1">{{
                  data.budgetMin + "-" + data.budgetMax
                }}</span>
                <span class="red" v-else>无预算</span>
              </p>
            </div>
            <div class="flex-item-center box_mesg">
              <p>
                需求方名称：<span class="red">{{ data.buyer }}</span>
              </p>
              <p>距离报价截止剩余：<span class="red" v-if="data.secondBidding == 1">{{ data.daysSecond }}天</span><span class="red" v-else>{{ data.days }}天</span></p>
              <p>
                当前参与竞标数：<span class="red">{{ data.offerNum }}</span>
              </p>
            </div>
          </div>
          <div>
            <el-button v-if="isOffered == 1" type="warning" disabled>已报价</el-button>
            <el-button v-else-if="data.status == 'UN_OFFERD' && !isSelf" type="primary" @click="checkStatus">参与报价</el-button>
          </div>
        </div>
      </div>
      <div class="demand_steps">
        <p class="tilteMesg">流程进度</p>
        <el-steps :active="step" align-center style="margin-top: 20px">
          <el-step
            v-for="(item, index) in stepList"
            :title="item.title"
            :key="index"
          ></el-step>
        </el-steps>
      </div>
      <div class="demandDetails_mesg">
        <div class="mesg_bob_left">
          <div class="left_box bacgk">
            <p class="tilteMesg">项目基础信息</p>
            <div class="left_box_nums">
              <p class="left_box_megs">
                <span class="left_box_megs_title">项目/产品分类：</span>
                <span
                  >一级分类:{{ data.classifyOneName }} 二级分类:{{
                    data.classifyTwoName
                  }}</span
                >
              </p>
              <p class="left_box_megs">
                <span class="left_box_megs_title">买家地址： </span>
                <span
                  >{{ data.addProvince }}-{{ data.addCity }}-{{
                    data.addArea
                  }}</span
                >
              </p>
              <p class="left_box_megs">
                <span class="left_box_megs_title">交付地址： </span>
                <span
                  >{{ data.addDueProvince }}-{{ data.addDueCity }}-{{
                    data.addDueArea
                  }}
                </span>
              </p>
              <p class="left_box_megs">
                <span class="left_box_megs_title">详细交付地址： </span>
                <span>{{ data.addFull }} </span>
              </p>
            </div>
          </div>
          <div class="left_box bacgk" v-if="data.demandType == 'SERVICE'">
            <p class="tilteMesg">需求详情</p>
            <div class="left_box_nums">
              <p class="left_box_megs">
                <span class="left_box_megs_title">需求描述： </span>
                <span>{{ data.demandDes }}</span>
              </p>
              <p class="left_box_megs">
                <span class="left_box_megs_title">附件：</span>
                <span
                  style="color: #099; cursor: pointer"
                  @click="downloadFile(data.url, data.fileName)"
                  >{{ data.fileName }}</span
                >
              </p>
            </div>
          </div>
          <div v-else class="left_box bacgk">
            <p class="tilteMesg">需求详情</p>
            <div class="left_box_nums">
              <p class="left_box_megs">
                <span class="left_box_megs_title">询价类型：</span>
                {{ data.inquiryType == 1 ? "现货/标准产品" : "加工/定制品" }}
              </p>
              <p class="left_box_megs">
                <span class="left_box_megs_title">规格型号： </span>{{ data.specifications }}
              </p>
              <p class="left_box_megs">
                <span class="left_box_megs_title">采购量：</span> {{ data.purchaseVolume }}
              </p>
            </div>
          </div>
          <div class="left_box bacgk">
            <p class="tilteMesg">交易预设</p>
            <div class="left_box_nums">
              <p class="left_box_megs">
                <span class="left_box_megs_title">税务发票： </span>
                <span>{{ data.invoiceType }} </span>
              </p>
              <p class="left_box_megs">
                <span class="left_box_megs_title">支付方式： </span>
                <span>{{ data.payTypeCn }} </span>
              </p>
              <p class="left_box_megs">
                <span class="left_box_megs_title">结款周期： </span>
                <span>{{ data.paymentCycle }} </span>
              </p>
              <p class="left_box_megs">
                <span class="left_box_megs_title">报价要求： </span>
                <span>{{ data.paymentClaim }} </span>
              </p>
            </div>
          </div>
          <div class="left_box bacgk" ref="demandMesgRefs">
            <p class="tilteMesg">竞标要求</p>
            <div class="left_box_flex left_box_nums">
<!--              <p class="left_box_megs">
                <span class="left_box_megs_title">接包地域： </span>
                <span>{{
                  data.sellerAddType == 1 ? "全国" : data.sellerAddFull
                }}</span>
              </p>-->
              <p class="left_box_megs">
                <span class="left_box_megs_title">卖家类型： </span>
                <span>{{ data.sellerTypeCn }}</span>
              </p>
<!--              <p class="left_box_megs" v-if="data.sellerType == 'EXCLUSIVE'">
                <span class="left_box_megs_title">卖家：</span>
                {{ sellers }}
              </p>-->
              <p class="left_box_megs">
                <span class="left_box_megs_title">报价截止时间： </span>
                <span>{{ data.deadline }}</span>
              </p>
              <p class="left_box_megs">
                <span class="left_box_megs_title">项目截止时间： </span>
                <span>{{ data.expectedDeliveryTime }} </span>
              </p>
              <!--              <p class="left_box_megs" style="width: 100%">
                <span class="left_box_megs_title">时间节点： </span>
                <span>
                  <el-table :data="tableData" border style="width: 100%">
                    <el-table-column prop="date" label="时间" width="330">
                    </el-table-column>
                    <el-table-column prop="name" label="进度描述" width="330">
                    </el-table-column>
                  </el-table>
                </span>
              </p>-->
            </div>
          </div>
          <demandDetailsOffer ref="demandDetailsOfferRefs"></demandDetailsOffer>
        </div>
        <div class="mesg_bob_right">
          <demandDetailsRight ref="demandDetailsRightRefs"></demandDetailsRight>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import demandDetailsOffer from "./demandDetailsOffer";
import demandDetailsRight from "./demandDetailsRight";
import {
  checkIsGoldProvider,
  getDemandInfo,
  getNewcurrent,
  getProviderIdentity,
  offerPage, reportOffer, saveVisitorLog
} from "../../../../utils/interface";
import {mapState} from "vuex";
export default {
  components: { demandDetailsOffer, demandDetailsRight },
  data() {
    return {
      demandId: "",
      sellers: "",
      data: {},
      userMessages:{},
      step: 0,
      isOffered:0,
      isSelf: false,
      signUp: false,
      isProvider: false,
      isGoldProvider: false,
      stepList: [
        {
          title: "需求报价",
        },
        {
          title: "已选标",
        },
        {
          title: "签署协议",
        },
        {
          title: "订单支付",
        },
        {
          title: "提供服务",
        },
        {
          title: "服务验收",
        },
        {
          title: "服务评价",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  created() {
    if(this.$store.state.isLogin) {
      // 获取用户信息
      getNewcurrent()
          .then((res) => {
            this.userMessages = res;
          })
          .catch((err) => {
            console.log(err);
          });
      //是否是服务商
      getProviderIdentity()
          .then((res) => {
            if(res && res.data == 1){
              this.isProvider = true;
            }
          })
          .catch((err) => {
            console.log(err);
          });

      //是否是金牌服务商
      checkIsGoldProvider()
          .then((res) => {
            if(res && res.data == 1){
              this.isGoldProvider = true;
            }
          })
          .catch((err) => {
            console.log(err);
          });
    }
    this.demandId = this.$route.query.uuid;
    getDemandInfo(this.demandId).then((resp) => {
      if (null !== resp) {
        this.data = resp.data;
        /*if(resp.data.sellerType == 'EXCLUSIVE' && resp.data.resUserVos && resp.data.resUserVos.length > 0){
          let orgs = '';
          resp.data.resUserVos.forEach(e => {
            orgs = orgs + e.orgName+'，';
          });
          if(orgs.length > 0){
            this.sellers = orgs.substring(0, orgs.length - 1);
          }
        }*/

        if (this.data.status == "UN_OFFERD") {
          this.step = 0;
        } else if (this.data.status == "UN_SIGNED") {
          this.step = 1;
        } else if (this.data.status == "UN_PAY") {
          this.step = 2;
        } else if (this.data.status == "UN_DESIGN") {
          this.step = 3;
        } else if (this.data.status == "UN_ACCEPTED") {
          this.step = 4;
        } else if (this.data.status == "UN_APPRAISE") {
          this.step = 5;
        } else if (this.data.status == "FINISHED") {
          this.step = 7;
        }

        this.saveVisitorLog()
        offerPage({demandId:this.demandId}).then(resp1=>{
          if(null !== resp1 && resp1.data.length > 0){
            this.isOffered = 1;
          }
        });
      }
    });
  },
  mounted() {
    setTimeout(() => {
      this.getInitializeNum();
    }, 500);
  },
  methods: {    // 初始化数据
    getInitializeNum(){
      if(this.$store.state.isLogin) {
        if(this.data.creator == this.userMessages.uuid){
          this.isSelf = true;
          this.$refs.demandDetailsOfferRefs.init(true, this.demandId, this.data.secondBidding, this.data.status);
        }else{
          if(this.data.sellerType == 'EXCLUSIVE'){
            if(this.data.resUserVos && this.data.resUserVos.length > 0){
              this.data.resUserVos.forEach(e => {
                if(this.userMessages.enterpriseUuid == e.enterpriseId){
                  this.signUp = true;
                }
              });
            }
            if(this.signUp){
              this.isSelf = false;
            } else{
              this.isSelf = true;
            }
          } else if(this.data.sellerType == 'GOLD' && this.isGoldProvider){
            this.isSelf = false;
          } else if(this.data.sellerType == 'ALL' && this.isProvider){
            this.isSelf = false;
          } else{
            this.isSelf = true;
          }

          this.$refs.demandDetailsOfferRefs.init(this.isSelf, this.demandId, this.data.secondBidding, this.data.status);
        }
      } else{
        this.isSelf = false;
        this.$refs.demandDetailsOfferRefs.init(false, this.demandId, this.data.secondBidding, this.data.status);
      }
      this.$refs.demandDetailsRightRefs.init(this.demandId, this.data.classifyOneUuid,this.data.classifyTwoUuid,this.data.creator);
    },
    checkStatus(){
      if(this.$store.state.isLogin) {
        //跳转到页面下方报价模块
        let targetLocation = this.$refs.demandMesgRefs;
        targetLocation.scrollIntoView();
      }else{
        this.$message({
          type: "success",
          message: "您需要先登录哦！",
        });
        this.$router.push('/login')
      }
    },
    downloadFile(url,name) {
      fetch(url).then((res) => {
        res.blob().then((blob) => {
          const blobUrl = window.URL.createObjectURL(blob);
          // 这里的文件名根据实际情况从响应头或者url里获取
          const filename = name;
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        });
      });
    },
    saveVisitorLog() {
      let price=0;
      if(this.data.budgetType == 0){
        price = this.data.budgetPrice
      }else if(this.data.budgetType == 1){
        price = this.data.budgetMin + "-" + this.data.budgetMax
      }
      let param = {
        title: this.data.demandName,
        visitorType: 'DESIGN',
        price: price,
        link: window.location.href
      };
      saveVisitorLog(param);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../style/index.less";
.demandBox {
  background: #f5f8fc;
}

.demandDetails {
  padding: 20px 0;
  .bacgk {
    background: #fff;
    padding: 0;
    border-radius: 0;
  }
  .breadcrumb {
    color: #999999;
  }

  .demandDetails_box {
    h3 {
      border-bottom: 1px solid #e8e8e8;
      padding: 22px 38px;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
    }
    .box_mesg_cont {
      padding: 16px 37px 26px;
    }
    .box_mesg {
      line-height: 30px;
      font-size: 14px;
      color: #333;
      p {
        width: 330px;
      }
    }
  }
  .demand_steps {
    background: #fff;
    margin-top: 20px;
    padding-bottom: 28px;
  }
  .demandDetails_mesg {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    .mesg_bob_left {
      width: 885px;
      flex-shrink: 0;
      box-sizing: border-box;
      .left_box {
        margin-bottom: 20px;
        .left_box_nums {
          padding: 16px 37px;
        }
        .left_box_megs {
          font-size: 14px;
          display: flex;
          color: #333;
          margin-bottom: 20px;
          .left_box_megs_title {
            display: inline-block;
            font-weight: 600;
            white-space: nowrap;
          }
        }
        .left_box_flex {
          display: flex;
          flex-wrap: wrap;
          .left_box_megs {
            width: 30%;
          }
        }
      }
    }
    .mesg_bob_right {
      width: 300px;
      box-sizing: border-box;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/supplyHome/components/details/demandDetails.vue